import { Link } from 'react-router-dom'
import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'
import './Home.css'

const defaultServices = [
  { title: 'Corporate Tax Returns', description: 'Comprehensive tax return services to ensure compliance and maximize savings.', linkText: 'Corporate Tax' },
  { title: 'Personal Tax Returns', description: 'Expert guidance to help you file accurately and optimize your refund.', linkText: 'Personal Tax' },
  { title: 'Financial Statements & Bookkeeping', description: 'Professional bookkeeping and financial analysis for business insights.', linkText: 'Book keeping' },
  { title: 'Tax Planning & Strategy', description: 'Proactive strategies to minimize tax liability and maximize wealth.', linkText: 'Tax Planning' },
  { title: 'Business Incorporation', description: 'Complete assistance with business setup and incorporation services.', linkText: 'Incorporation' },
  { title: 'Payroll Management', description: 'Efficient payroll processing and compliance for your business.', linkText: 'Payroll' },
]

function Home() {
  const settings = useQuery(api.siteSettings.get)
  const dbServices = useQuery(api.services.listActive)

  const services = dbServices && dbServices.length > 0 ? dbServices : defaultServices

  const heroTitle = settings?.heroTitle ?? "Expert Tax &\nAccounting Services"
  const heroSubtitle = settings?.heroSubtitle ?? "Get the best value for bookkeeping, CFO, and tax services for startups and scale-ups."
  const heroCta = settings?.heroCta ?? "Lets Talk"
  const servicesHeading = settings?.servicesHeading ?? "One team for all your\naccounting needs"
  const servicesSubheading = settings?.servicesSubheading ?? "Comprehensive financial solutions tailored to your needs, from individual tax returns to full-service business accounting."
  const ctaHeading = settings?.ctaHeading ?? "Ready to Improve Your Financial Health?"
  const ctaSubheading = settings?.ctaSubheading ?? "Schedule a consultation with our expert accountants today"

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              {heroTitle.split('\n').map((line, i) => (
                <span key={i}>{line}{i < heroTitle.split('\n').length - 1 && <br />}</span>
              ))}
            </h1>
            <p className="hero-subtitle">{heroSubtitle}</p>
            <Link to="/appointment" className="btn-cta">
              {heroCta} <span className="btn-arrow">&rarr;</span>
            </Link>
          </div>
          <div className="hero-image">
            <div className="hero-image-wrapper">
              <img src="/images/about.jpg" alt="Professional accountant" />
              <div className="circle-accent circle-1"></div>
              <div className="circle-accent circle-2"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <div className="services-header">
            <h2>
              {servicesHeading.split('\n').map((line, i) => (
                <span key={i}>{line}{i < servicesHeading.split('\n').length - 1 && <br />}</span>
              ))}
            </h2>
            <p className="section-description">{servicesSubheading}</p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={service._id ?? index} className="service-card">
                <div className="service-icon-wrapper">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to="/contact" className="service-link">
                  {service.linkText} <span>&rarr;</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container cta-container">
          <h2>{ctaHeading}</h2>
          <p>{ctaSubheading}</p>
          <Link to="/appointment" className="btn-cta btn-cta-dark">
            Book Your Consultation <span className="btn-arrow">&rarr;</span>
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Home
